export default class Index
{
	static message_sent(success)
	{
		if(!success) return
		setTimeout(() => location.href = '/sent', 2500)
	}

	static type(type)
	{
		if(type === 'salon')
		{
			$('#_request').show()
			$('#_request input').prop('disabled', false)
		}
		else
		{
			$('#_request').hide()
			$('#_request input').prop('disabled', true)
		}
	}
}
